import { FilterCard, FilterLabel } from "./primitives";
import "./confidence-card.css";

export function ConfidenceCard({
  value,
  onChange,
  label = "Confidence score",
  className = "h-20 justify-center w-full",
  disabled = false,
  labelSize = "tiny",
}: {
  value: number;
  onChange: (next: number) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  labelSize?: "tiny" | "small";
}) {
  // Slider is constrained to 80–99 (ref app's confidence range). Map value to track position (0–100%).
  const pct = Math.max(0, Math.min(100, ((value - 80) / 19) * 100));
  return (
    <FilterCard className={className} disabled={disabled}>
      <FilterLabel size={labelSize}>{label}</FilterLabel>
      <div className="flex w-full items-center gap-2">
        <input
          type="range"
          min={80}
          max={99}
          step={1}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          aria-label="Confidence score"
          disabled={disabled}
          className="confidence-slider flex-1"
          style={{ "--pct": `${pct}%` } as React.CSSProperties}
        />
        <span
          className={`text-small font-medium tabular-nums ${disabled ? "text-grey-500" : "text-grey-900"}`}
        >
          {value}%
        </span>
      </div>
    </FilterCard>
  );
}
